import { combineReducers } from 'redux';
import hierarchyReducer from './reducers/assetHierarchy.reducer';
// import { DashboardMachinesList } from './dashboard.machines.reducer';
// import { dashboardActivityList, DashboardActivitySorter } from './dashboard.activity.reducer';

export const assetHierarchyReducer = combineReducers({
  assetInfo: hierarchyReducer,
});
